import styled from '@emotion/styled'
import { spacer, SpacerDefs } from '@pharmac/ui'
import { CSSProperties, HTMLAttributes, PropsWithChildren } from 'react'
import { joinClasses } from './joinClasses'

type ExtranetTableColumnRootProps = {
  flexGrow?: number
  flexAlign?: string
  flexJustify?: string
  textAlign?: string
  shortHeight?: boolean
} & SpacerDefs

export const ExtranetTableColumnRoot = styled.div<ExtranetTableColumnRootProps>`
  display: inline-flex;
  flex: ${(p) => p.flexGrow || 1} 1 0%;
  align-items: ${({ flexAlign }) => (!!flexAlign ? flexAlign : 'center')};
  justify-content: ${({ flexJustify }) => (!!flexJustify ? flexJustify : 'flex-start')};

  overflow: hidden;
  white-space: normal;
  text-overflow: ellipsis;
  min-height: ${({ shortHeight }) => (shortHeight ? '35px' : '54px')};

  &.entable__column--group {
    .entable__row {
      background-color: transparent;
      border-radius: 0;
      border: none;
      margin-bottom: 0;
    }
  }
`

const ExtranetTableColumnInnerRoot = styled.div<ExtranetTableColumnRootProps>`
  padding: var(--table-padding);
  text-align: ${({ textAlign }) => textAlign || 'left'};
  ${spacer}
`
export type ExtranetTableColumnProps = {
  size?: number
  innerStyle?: CSSProperties
  flexAlign?: 'center' | 'flex-start' | 'flex-end'
  flexJustify?: 'center' | 'flex-start' | 'flex-end'
  textAlign?: 'right' | 'left' | 'center'
  shortHeight?: boolean
} & SpacerDefs &
  PropsWithChildren &
  HTMLAttributes<HTMLDivElement>

export const ExtranetTableColumn = ({
  size,
  style,
  className,
  innerStyle,
  flexAlign,
  flexJustify,
  textAlign,
  shortHeight,
  ...props
}: ExtranetTableColumnProps) => {
  return (
    <ExtranetTableColumnRoot
      className={joinClasses('entable__column', className)}
      flexGrow={size}
      style={style}
      flexAlign={flexAlign}
      flexJustify={flexJustify}
      shortHeight={shortHeight}
    >
      <ExtranetTableColumnInnerRoot
        className="entable__column--inner"
        style={innerStyle}
        textAlign={textAlign}
        {...props}
      >
        {props.children}
      </ExtranetTableColumnInnerRoot>
    </ExtranetTableColumnRoot>
  )
}
